import { Box, CircularProgress, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

import { ModalContentContainer } from '@/components';
import {
  selectActiveModalParams,
  selectEpisodeCompliance,
  uiActions,
  useAppSelector,
  useFetchEpisodeQuery,
} from '@/store';

import { ShareEpisodeForm } from '../ShareEpisodeForm';

export const ShareEpisodeModalContent = () => {
  const dispatch = useDispatch();
  const { episodeId, referrer } = useSelector(selectActiveModalParams) || {};
  const compliance = useAppSelector(state =>
    selectEpisodeCompliance(state, episodeId),
  );

  const { data: episode } = useFetchEpisodeQuery(
    { episodeId, compliance },
    { skip: !episodeId },
  );

  const onClose = () => dispatch(uiActions.closeActiveModal());

  return (
    <Box sx={{ width: { xs: 'auto', md: 800 } }}>
      <ModalContentContainer
        onModalClose={onClose}
        stretch
        leftColumnContents={
          <Box sx={{ maxWidth: 200, mx: 'auto' }}>
            {!!episode && (
              <>
                <Box
                  component="img"
                  alt="episode cover"
                  sx={[
                    {
                      width: 200,
                      height: 200,
                      borderRadius: 4,
                      overflow: 'hidden',
                      boxShadow: '0px 4px 12px 0px rgba(0, 0, 0, 0.65)',
                      objectFit: 'cover',
                      objectPosition: 'center',
                      mb: 1.5,
                    },
                  ]}
                  src={episode.cover}
                />
                <Typography variant="h4" sx={{ color: 'text.contrast' }}>
                  {episode.name}
                </Typography>
              </>
            )}
          </Box>
        }>
        {episode ? (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              height: '100%',
              color: 'text.main',
              gap: 1.5,
            }}>
            <Typography variant="h2">Share Episode</Typography>
            <ShareEpisodeForm
              episodeId={episode.episodeId}
              episodeDeeplink={episode.deepLink}
              referrer={referrer}
            />
          </Box>
        ) : (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: 400,
            }}>
            <CircularProgress />
          </Box>
        )}
      </ModalContentContainer>
    </Box>
  );
};
